import useSWR from "swr";
import { adminLoyaltyService } from "../../api_client";
import type {
  LoyaltyAnalyticsDto,
  LoyaltyAnalyticsSummaryDto,
  TimeSeriesBucketDto,
} from "../../../api";

export type { LoyaltyAnalyticsDto, LoyaltyAnalyticsSummaryDto, TimeSeriesBucketDto };

interface AnalyticsQuery {
  startDate: string;
  endDate: string;
  granularity?: "week" | "month";
}

export function useAdminLoyaltyAnalytics(query: AnalyticsQuery) {
  return useSWR<LoyaltyAnalyticsDto>(
    `admin-loyalty-analytics:${query.startDate}:${query.endDate}:${query.granularity ?? "week"}`,
    async () => {
      const res = await adminLoyaltyService.getAnalytics(
        query.startDate,
        query.endDate,
        query.granularity ?? "week",
      );
      return res.data;
    },
    { revalidateOnFocus: false },
  );
}
